import { useState, useEffect } from 'react'
import ReEnterBankPopup from 'features/notifications/components/ReEnterBankPopup'
import { useNavigate } from 'react-router-dom'
import { handleRequestError } from 'api/handleRequestError'
import * as notificationsApi from 'features/notifications/api/notifications.api'
import { useAuth } from 'features/auth/store/authStore'

const CustomTriggerPadPopupEvent = () => {
  const { setRole, setToken, setRegistrationToken } = useAuth()

  const navigate = useNavigate()
  const [showPopup, setShowPopup] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    const listener = () => {
      setShowPopup(true)
    }

    window.addEventListener('triggerPadPopup', listener)

    return () => {
      window.removeEventListener('triggerPadPopup', listener)
    }
  }, [])

  const handleConfirm = async () => {
    setIsSubmitting(true)
    try {
      const response = await notificationsApi.resetFinancialDetails()

      if (response.data.success) {
        setRole(null)
        setToken(null)
        setRegistrationToken(response.data.token)
        navigate('/registration/process')
      }
    } catch (error) {
      handleRequestError(error)
    } finally {
      setIsSubmitting(false)
      setShowPopup(false)
    }
  }

  return showPopup ? (
    <ReEnterBankPopup onConfirm={handleConfirm} isSubmitting={isSubmitting} />
  ) : null
}

export default CustomTriggerPadPopupEvent
